import { useTranslation } from 'react-i18next';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';
import { Banner } from '@/components/ui/Banner';

export function OfflineBanner(): JSX.Element | null {
  const online = useOnlineStatus();
  const { t } = useTranslation();
  if (online) return null;
  return <Banner variant="warning">{t('errors.offline')}</Banner>;
}
